(function () {
    'use strict';

    let widgetId = 0;
    let lastHeight = -1;
    let frameScheduled = false;

    function measure() {
        const doc = document.documentElement;
        const body = document.body;
        if (!body) return 0;

        return Math.max(
            body.scrollHeight, body.offsetHeight,
            doc.scrollHeight, doc.offsetHeight, doc.clientHeight
        );
    }

    function send() {
        frameScheduled = false;

        const height = measure();
        if (height === lastHeight) return;
        lastHeight = height;

        try {
            // targetOrigin is '*' rather than window.location.origin because a sandboxed iframe without
            // allow-same-origin has an OPAQUE origin, for which location.origin serialises to the string
            // "null" — not a valid targetOrigin, so postMessage would throw and the resize would never
            // be sent. '*' is safe here: the payload is a type string and two integers, with nothing
            // confidential to leak to whoever is listening. The parent does not trust the origin either
            // way — it authenticates the sender by matching event.source against the iframe element it
            // is about to resize.
            window.parent.postMessage({
                type: 'code-widget:resize',
                id: widgetId,
                height: height
            }, '*');
        } catch (e) {
            // Parent not reachable (e.g. top-level navigation) — give up silently.
        }
    }

    function schedule() {
        if (frameScheduled) return;
        frameScheduled = true;
        (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(send);
    }

    window.CodeWidgetFrame = {
        start: function (id) {
            widgetId = id;

            if (window.parent === window) return; // not embedded

            schedule();

            if ('ResizeObserver' in window) {
                const ro = new ResizeObserver(schedule);
                ro.observe(document.body);
                ro.observe(document.documentElement);
            } else {
                window.addEventListener('load', schedule);
                window.addEventListener('resize', schedule);
                setInterval(schedule, 500);
            }
        }
    };
})();
